export default {
  labels: {
    custom: 'Personalizzato – Disponibile su richiesta',
    was: 'Era {{amount}} – sconto annuale applicato',
  },
  tags: {
    preferred: 'Particolarmente popolare',
    net_one_time: 'una tantum netto',
    annual_discount: '-{{percentage}}% annuale',
  },
  buttons: {
    select_plan: 'Scegli questo piano',
  },
};
